













import Vue from 'vue'

export default Vue.extend({
  props: {
    subjectName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      names: {
        国語:
            parseInt(this.$store.state.grade.name[1]) < 3 ? '<ruby>国語<rt>こくご</rt></ruby>'
                            : '国語',
        算数:
            parseInt(this.$store.state.grade.name[1]) < 3 ? '<ruby>算数<rt>さんすう</rt></ruby>'
                            : '算数',
        思考の達人ツール:
            parseInt(this.$store.state.grade.name[1]) < 5 ? '<ruby>思考<rt>しこう</rt></ruby>の<ruby>達人<rt>たつじん</rt></ruby>ツール'
                            : '思考の達人ツール',
        複合教科問題:
            '<ruby>複合教科問題<rt>ふくごうきょうかもんだい</rt></ruby>',
        添削テスト: '<ruby>添削<rt>てんさく</rt></ruby>テスト',
        えい語: 'えい<ruby>語<rt>ご</rt></ruby>',
        会報誌: '<ruby>会報誌<rt>かいほうし</rt></ruby>',
        ひらめき図形ブロック: 'ひらめき<ruby>図形<rt>ずけい</rt></ruby>',
        バックナンバー: 'バックナンバー',
        表紙:
            parseInt(this.$store.state.grade.name[1]) < 4 ? '<ruby>表紙<rt>ひょうし</rt></ruby>'
                            : '表紙',
      },

      colors: {
        国語: '#ff7f05',
        算数: '#3ea8bb',
        思考の達人ツール: '#52bb70',
        複合教科問題: '#8677c3',
        添削テスト: '#0063b2',
        えい語: '#fc7e7e',
        会報誌: '#0063b2',
        ひらめき図形ブロック: '#0063b2',
        バックナンバー: '#3b2a1c',
        表紙: '#9a8a6a',
      }
    }
  }
})
